import axios from 'axios'

import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const REQUEST_REFERRALS = 'REQUEST_REFERRALS'
export const RECEIVE_REFERRALS = 'RECEIVE_REFERRALS'
export const SEND_REFERRAL_EMAIL = 'SEND_REFERRAL_EMAIL'

export const requestReferrals = () => (dispatch, getState) => {
    dispatch({ type: REQUEST_REFERRALS })

    const { profile } = getState()

    const { id: userId } = profile

    axios
        .get(`/users/${userId}/referrals`)
        .then((response) => {
            const items = response?.data || []

            dispatch(receiveReferrals({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveReferrals({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveReferrals({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveReferrals = (data) => ({ type: RECEIVE_REFERRALS, data })

export const sendReferralEmail = (emailAddress) => (dispatch) => {
    dispatch({ type: SEND_REFERRAL_EMAIL, data: { emailAddress } })

    return axios
        .post('/referrals/email', { emailAddress })
        .then(() => {
            dispatch(receiveSuccessAlert('La invitación ha sido enviada correctamente. Envía más, gana más.'))
        })
        .catch((error) => {
            dispatch(
                handleRequestError(error, {
                    customMessage:
                        'Ha habido un problema enviando el correo electrónico. Por favor, comprueba la dirección o inténtalo de nuevo más tarde.',
                    hideAlert: true,
                })
            )

            return Promise.reject(error)
        })
}
